import { createSlice } from "@reduxjs/toolkit";
import { VerifyCredentials, getOTP } from "../../actions/auth/auth";

const initialState = {
  isLoggedInUser: null,
  userLoggedInDetails: {},
  otpSent: false,
  loading: false,
  error: null,
};

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    resetOtpState: (state) => {
      state.otpSent = false;
      state.error = null;
    },
  },
  extraReducers: {
    // Get OTP reducers
    [getOTP.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [getOTP.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.otpSent = true;
      state.error = null;
    },
    [getOTP.rejected]: (state, action) => {
      state.loading = false;
      state.otpSent = false;

      // Handle API error response
      if (action.payload && action.payload.error) {
        // This handles when you return rejectWithValue(response.data)
        state.error = action.payload.error;
      } else if (action.error && action.error.message) {
        // This handles network errors or other issues
        state.error = action.error.message;
      } else {
        state.error = "Failed to send OTP. Please try again.";
      }
    },

    // Verify Credentials reducers
    [VerifyCredentials.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [VerifyCredentials.fulfilled]: (state, { payload }) => {
      state.loading = false;
      if (payload.token) {
        localStorage.setItem("token", payload.token);
        state.isLoggedInUser = true;
        state.userLoggedInDetails = payload;
      }
      state.error = null;
    },
    [VerifyCredentials.rejected]: (state, action) => {
      state.loading = false;

      // Handle API error response
      if (action.payload && action.payload.error) {
        state.error = action.payload.error;
      } else if (action.error && action.error.message) {
        state.error = action.error.message;
      } else {
        state.error = "Verification failed. Please try again.";
      }
    },
  },
});

export const { clearError, resetOtpState } = loginSlice.actions;
export default loginSlice.reducer;
